module.exports = __webpack_public_path__ + "img/img0.417db5ca.jpg";